import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const CutBlueSphereTop = ({
  hideGrain,
  svgProps,
}: {
  hideGrain?: boolean
  svgProps: React.SVGProps<SVGSVGElement>
}) => {
  const uniqueId = useId()
  const maskId = `grainFilter-cut-blue-sphere-top-${uniqueId}`

  return (
    <svg
      {...svgProps}
      viewBox="0 0 1439 1185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4732_2080)">
        <g filter="url(#filter0_f_4732_2080)">
          <ellipse
            cx="1155.7"
            cy="1118.35"
            rx="1155.7"
            ry="1118.35"
            transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 -430.424 165)"
            fill="url(#paint0_radial_4732_2080)"
          />
        </g>
        <g filter="url(#filter1_f_4732_2080)">
          <ellipse
            cx="1070.89"
            cy="1036.29"
            rx="1070.89"
            ry="1036.29"
            transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 -345.624 247.062)"
            fill="url(#paint1_radial_4732_2080)"
          />
        </g>
        <g filter="url(#filter2_f_4732_2080)">
          <ellipse
            cx="1013.69"
            cy="956.888"
            rx="1013.69"
            ry="956.888"
            transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 -288.418 350.512)"
            fill="url(#paint2_radial_4732_2080)"
          />
        </g>
        <g filter="url(#filter3_d_4732_2080)">
          <ellipse
            cx="815.38"
            cy="789.032"
            rx="815.38"
            ry="789.032"
            transform="matrix(0.999998 -0.00184243 0.00196626 0.999999 -91.6621 469.822)"
            fill="url(#paint3_radial_4732_2080)"
          />
        </g>
        <g filter="url(#filter4_f_4732_2080)">
          <circle
            cx="729.268"
            cy="1269.74"
            r="770.392"
            fill="white"
            fillOpacity="0.8"
          />
        </g>
        <g filter="url(#filter5_f_4732_2080)">
          <circle cx="725.267" cy="1293.74" r="708.76" fill="#176AE5" />
        </g>
        <g filter="url(#filter6_f_4732_2080)">
          <circle cx="725.268" cy="1260.1" r="390.292" fill="#81D3FF" />
        </g>
        <g
          filter="url(#filter7_f_4732_2080)"
          data-figma-bg-blur-radius="8.02838"
        >
          <path
            d="M2065.56 1756.83L721.129 1759.39L-623.306 1761.95L-624.754 1001.71L2064.12 996.591L2065.56 1756.83Z"
            fill="url(#paint4_linear_4732_2080)"
            fillOpacity="0.01"
          />
        </g>
        <g filter="url(#filter8_f_4732_2080)">
          <circle
            cx="725.267"
            cy="1280.74"
            r="973.126"
            stroke="#F9EFE4"
            strokeWidth="1.59202"
          />
        </g>
        <g
          filter="url(#filter9_f_4732_2080)"
          data-figma-bg-blur-radius="8.02838"
        >
          <path
            d="M1495.66 1009.51L529.474 748.65L-436.708 487.789L-669.997 1351.85L1262.37 1873.57L1495.66 1009.51Z"
            fill="url(#paint5_linear_4732_2080)"
            fillOpacity="0.01"
          />
        </g>
        <g
          filter="url(#filter10_f_4732_2080)"
          data-figma-bg-blur-radius="8.02838"
        >
          <path
            d="M1056.88 226.644L932.849 210.74L-293.583 516.321L1056.88 423.827L1252.32 376.226L1505.32 226.644L1056.88 226.644Z"
            fill="url(#paint6_linear_4732_2080)"
            fillOpacity="0.01"
          />
        </g>
        <g filter="url(#filter11_f_4732_2080)">
          <circle
            cx="17.1299"
            cy="17.1299"
            r="17.1299"
            transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 1089.88 389.733)"
            fill="white"
          />
        </g>
        <g
          filter="url(#filter12_f_4732_2080)"
          data-figma-bg-blur-radius="8.02838"
        >
          <path
            d="M2647.01 456.162L1680.34 715.183L713.66 974.202L945.303 1838.71L2878.66 1320.66L2647.01 456.162Z"
            fill="url(#paint7_linear_4732_2080)"
            fillOpacity="0.01"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_4732_2080"
          x="-468.08"
          y="127.346"
          width="2386.7"
          height="2312.01"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="18.8271"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <filter
          id="filter1_f_4732_2080"
          x="-393.39"
          y="199.298"
          width="2237.32"
          height="2168.11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="23.8821"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <filter
          id="filter2_f_4732_2080"
          x="-392.351"
          y="246.581"
          width="2235.24"
          height="2121.64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="51.9656"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <filter
          id="filter3_d_4732_2080"
          x="-154.026"
          y="378.838"
          width="1758.59"
          height="1705.89"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-25.5657" />
          <feGaussianBlur stdDeviation="31.9571" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4732_2080"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4732_2080"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_f_4732_2080"
          x="-85.024"
          y="455.446"
          width="1628.58"
          height="1628.58"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="21.95"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <filter
          id="filter5_f_4732_2080"
          x="-147.697"
          y="420.775"
          width="1745.93"
          height="1745.93"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="82.1022"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <filter
          id="filter6_f_4732_2080"
          x="-75.5343"
          y="459.297"
          width="1601.61"
          height="1601.61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="205.255"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <filter
          id="filter7_f_4732_2080"
          x="-746.05"
          y="875.295"
          width="2932.91"
          height="1007.95"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="60.6479"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <clipPath
          id="bgblur_1_4732_2080_clip_path"
          transform="translate(746.05 -875.295)"
        >
          <path d="M2065.56 1756.83L721.129 1759.39L-623.306 1761.95L-624.754 1001.71L2064.12 996.591L2065.56 1756.83Z" />
        </clipPath>
        <filter
          id="filter8_f_4732_2080"
          x="-252.126"
          y="303.348"
          width="1954.79"
          height="1954.79"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.73556"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <filter
          id="filter9_f_4732_2080"
          x="-881.162"
          y="276.624"
          width="2587.98"
          height="1808.11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="105.582"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <clipPath
          id="bgblur_2_4732_2080_clip_path"
          transform="translate(881.162 -276.624)"
        >
          <path d="M1495.66 1009.51L529.474 748.65L-436.708 487.789L-669.997 1351.85L1262.37 1873.57L1495.66 1009.51Z" />
        </clipPath>
        <filter
          id="filter10_f_4732_2080"
          x="-504.747"
          y="-0.424606"
          width="2221.23"
          height="727.91"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="105.582"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <clipPath
          id="bgblur_3_4732_2080_clip_path"
          transform="translate(504.747 0.424606)"
        >
          <path d="M1056.88 226.644L932.849 210.74L-293.583 516.321L1056.88 423.827L1252.32 376.226L1505.32 226.644L1056.88 226.644Z" />
        </clipPath>
        <filter
          id="filter11_f_4732_2080"
          x="1048.88"
          y="348.727"
          width="47.7526"
          height="47.7526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3.37322"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <filter
          id="filter12_f_4732_2080"
          x="502.495"
          y="244.997"
          width="2587.33"
          height="1804.87"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="105.582"
            result="effect1_foregroundBlur_4732_2080"
          />
        </filter>
        <clipPath
          id="bgblur_4_4732_2080_clip_path"
          transform="translate(-502.495 -244.997)"
        >
          <path d="M2647.01 456.162L1680.34 715.183L713.66 974.202L945.303 1838.71L2878.66 1320.66L2647.01 456.162Z" />
        </clipPath>
        <radialGradient
          id="paint0_radial_4732_2080"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1155.69 644.425) rotate(89.9999) scale(2161.77 2233.96)"
        >
          <stop offset="0.305" stopColor="#176BE5" />
          <stop offset="0.629788" stopColor="#EEBACB" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4732_2080"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1070.89 597.139) rotate(89.9999) scale(2003.15 2070.04)"
        >
          <stop offset="0.305" stopColor="#83D4FF" />
          <stop offset="0.629788" stopColor="#EEBACB" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4732_2080"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1013.69 551.386) rotate(89.9999) scale(1849.67 1959.47)"
        >
          <stop offset="0.305" stopColor="#ECB9CB" />
          <stop offset="0.629788" stopColor="#EEBACB" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4732_2080"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(815.585 684.685) rotate(90.0132) scale(893.379 923.212)"
        >
          <stop offset="0.205439" stopColor="#2877E7" />
          <stop offset="0.674426" stopColor="#75A8F0" />
          <stop offset="0.843487" stopColor="#B1CEF6" />
          <stop offset="0.93127" stopColor="#C9DDF9" />
          <stop offset="1" stopColor="white" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_4732_2080"
          x1="417.331"
          y1="2440.84"
          x2="416.554"
          y2="2032.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4732_2080"
          x1="519.151"
          y1="-84.4015"
          x2="393.885"
          y2="379.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4732_2080"
          x1="635.864"
          y1="-9.38445"
          x2="777.528"
          y2="146.627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4732_2080"
          x1="1253.51"
          y1="-0.288565"
          x2="1377.89"
          y2="463.911"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
        <clipPath id="clip0_4732_2080">
          <rect width="1439" height="1185" fill="white" />
        </clipPath>
        <mask id={maskId}>
          <rect width="100%" height="100%" fill="black" />
          <g filter="url(#filter0_f_4732_2080)">
            <ellipse
              cx="1155.7"
              cy="1118.35"
              rx="1155.7"
              ry="1118.35"
              transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 -430.424 165)"
              fill="white"
            />
          </g>
          <g filter="url(#filter1_f_4732_2080)">
            <ellipse
              cx="1070.89"
              cy="1036.29"
              rx="1070.89"
              ry="1036.29"
              transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 -345.624 247.062)"
              fill="white"
            />
          </g>
          <g filter="url(#filter2_f_4732_2080)">
            <ellipse
              cx="1013.69"
              cy="956.888"
              rx="1013.69"
              ry="956.888"
              transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 -288.418 350.512)"
              fill="white"
            />
          </g>
          <g filter="url(#filter3_d_4732_2080)">
            <ellipse
              cx="815.38"
              cy="789.032"
              rx="815.38"
              ry="789.032"
              transform="matrix(0.999998 -0.00184243 0.00196626 0.999999 -91.6621 469.822)"
              fill="white"
            />
          </g>
          <g filter="url(#filter4_f_4732_2080)">
            <circle cx="729.268" cy="1269.74" r="770.392" fill="white" />
          </g>
          <g filter="url(#filter5_f_4732_2080)">
            <circle cx="725.267" cy="1293.74" r="708.76" fill="white" />
          </g>
          <g filter="url(#filter6_f_4732_2080)">
            <circle cx="725.268" cy="1260.1" r="390.292" fill="white" />
          </g>
        </mask>
      </defs>

      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask={`url(#${maskId})`}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
